import {AfterViewInit, Directive, ElementRef, Input} from '@angular/core';

@Directive({
  selector: '[focoInicial]'
})
export class FocoInicialDirective implements AfterViewInit {

  @Input() focoInicial;

/*  Constrói a tela, instaciando todos os serviços a serem utilizados pela mesma
  Se necessário, checa as permissoes de usuário para permitir quais operações de Crud poderão ser executadas */
  constructor(private el: ElementRef) {
  }

  ngAfterViewInit() {
    if (this.focoInicial) {
      this.el.nativeElement.focus();
    }
  }

}
